<template>
    <div>

        <section class="tab">
            <ul class="nav nav-tabs justify-content-around" v-if="otanishinjiro_access_status!=1">
                <li class="nav-item" v-for="tab in tabs">
                    <a class="nav-link" :class="{ 'active': tab.id === tabIndex }" :href='`#tab-${tab.id}`'
                       data-toggle="tab" @click="switchTab(tab.id)">{{ characters[tab.type+'_type'] }}</a>
                </li>
            </ul>
            <div class="select_box" v-if="otanishinjiro_access_status!=1">
                <select v-model="sortIndex">
                    <option v-for="sort in sorts" :value="sort.id">{{ characters[sort.type+'_order'] }}</option>
                </select>
            </div>
            <div class="search_box" v-if="otanishinjiro_access_status!=1">
                <input id="title" v-model="title" placeholder="タイトル検索">
            </div>

            <div class="tab-content">
                <div id="tab-0" class="tab-pane active">
                    <div class="store-item screen-transition" v-for="item in items" @click="store_item_click(item.destination)">
                        <div class="item-image">
                            <img :src="item.image" class="profile-image">
                        </div>
                        <div class="item-info">
                            <div class="item-type" v-if="item_type_view_status == 1">{{ item.type_op }}&nbsp;{{ item.year}}</div>
                            <div class="item-title">{{ item.title }}</div>
                            <div class="item-content" v-if="digital_contents.includes(item.type) && item.content_count>1 && otanishinjiro_access_status!=1">{{ characters.album }}({{ item.content_count }}{{ characters.number_of_music }})</div>
                            <div class="item-content" v-if="digital_contents.includes(item.type) && item.content_count==1 && otanishinjiro_access_status!=1">{{ item.content_count }}{{ characters.number_of_music }}</div>
                        </div>
                        <div class="item-price-container">
                            <span class="item-price" v-if="item.type=='ticket' || (item.soldout_flag==0 && item.type=='goods') || (digital_contents.includes(item.type) && item.subscription_flag==0)">{{ '￥' + item.price.toLocaleString() }}{{ characters.otani_1 }}</span>
                            <span class="item-price" v-if="digital_contents.includes(item.type) && item.subscription_flag==1 && otanishinjiro_access_status==1">{{ '￥' + subscription_price.toLocaleString() }}</span>
                            <span class="item-price" v-if="item.soldout_flag==1">{{ characters.soldout }}</span>
                        </div>
                    </div>
                </div>
                <div id="tab-1" class="tab-pane">
                </div>
                <div id="tab-2" class="tab-pane">
                </div>
                <div id="tab-3" class="tab-pane">
                </div>
                <div id="tab-4" class="tab-pane">
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "store",
        props: ['default_type', 'tab_list_bit', 'item_type_view_status', 'otanishinjiro_access_status', 'json_characters'],
        data: function () {
            return {
                tabIndex: null,
                count: 0,
                subscription_price: 0,
                tabs: [],
                tab_origin: [
                    {id: 0, title: '全て', type: 'all'},
                    {id: 1, title: '音楽', type: 'music'},
                    {id: 2, title: 'ビデオ', type: 'video'},
                    {id: 3, title: 'グッズ', type: 'goods'},
                    {id: 4, title: '写真・画像', type: 'photo'},
                    {id: 5, title: 'チケット', type: 'ticket'}
                ],
                items: [],
                sortIndex: null,
                sorts: [
                    {id: 0, title: '新着順', type: 'new_arrival'},
                    {id: 1, title: '人気順', type: 'popularity'},
                    {id: 2, title: '年代順', type: 'chronological'}
                ],
                characters: Object,
                digital_contents: [
                    'music', 'video', 'photo',
                ],
                title: '',
            }
        },
        mounted() {
            this.setTab();
            this.getSubscriptionPrice();
            let tabIndex = this.getTabType(this.default_type)
            if(tabIndex !== null) {
                localStorage.setItem('store-tabIndex', tabIndex);
            }
            if (localStorage.getItem('store-tabIndex') === null) {
                tabIndex = 0;
            } else {
                tabIndex = Number(localStorage.getItem('store-tabIndex'));
            }
            this.tabIndex = tabIndex;
            this.characters = JSON.parse(this.json_characters);
        },
        methods: {
            switchTab: function (id) {
                this.tabIndex = id;
            },
            store_item_click: function (destination) {
                location.href = destination;
            },
            sortNewArrival() {
                let sortedItems = this.items.sort((a,b) => {
                    // 優先度が高い順でソートする
                    if(a.priority > b.priority) return -1;
                    if(a.priority < b.priority) return 1;
                    // 公開日時が新しい順にソートする
                    if(a.on_sale_time > b.on_sale_time) return -1;
                    if(a.on_sale_time < b.on_sale_time) return 1;
                    // 登録が新しい順にソートする
                    if(a.item_id > b.item_id) return -1;
                    if(a.item_id < b.item_id) return 1;
                    return 0;
                });
                this.items = sortedItems;
            },
            sortPopularity() {
                let sortedItems = this.items.sort((a,b) => {
                    // 優先度が高い順でソートする
                    if(a.priority > b.priority) return -1;
                    if(a.priority < b.priority) return 1;
                    // 人気度が高い順にソートする
                    if(a.popularity > b.popularity) return -1;
                    if(a.popularity < b.popularity) return 1;
                    // 登録が新しい順にソートする
                    if(a.item_id > b.item_id) return -1;
                    if(a.item_id < b.item_id) return 1;
                    return 0;
                });
                this.items = sortedItems;
            },
            sortOnSaleDate() {
                let sortedItems = this.items.sort((a,b) => {
                    // 優先度が高い順でソートする
                    if(a.priority > b.priority) return -1;
                    if(a.priority < b.priority) return 1;
                    // 公開日時が古い順にソートする
                    if(a.on_sale_time < b.on_sale_time) return -1;
                    if(a.on_sale_time > b.on_sale_time) return 1
                    // 登録が新しい順にソートする
                    if(a.item_id > b.item_id) return -1;
                    if(a.item_id < b.item_id) return 1;
                    return 0;
                });
                this.items = sortedItems;
            },
            sortItems: function(newIndex) {
                switch (newIndex) {
                    case 0:
                        this.sortNewArrival();
                        break;
                    case 1:
                        this.sortPopularity();
                        break;
                    case 2:
                        this.sortOnSaleDate();
                        break;
                }
            },
            getTabType: function(type) {
                const tab = this.tabs.find(element => element.type === type);
                if(tab) {
                    // console.log(tab);
                    return tab.id;
                }
                return null;
            },
            searchItem: function(type) {
                axios.default
                    .get('/store/list' + type + '?title='+this.title)
                    .then(response => {
                        this.items = response.data;
                        let sortIndex;
                        if (localStorage.getItem('store-sortIndex') === null) {
                            sortIndex = 0;
                            this.sortItems(0);
                        } else {
                            sortIndex = Number(localStorage.getItem('store-sortIndex'));
                            this.sortItems(sortIndex);
                        }
                        this.sortIndex = sortIndex;
                    });
            },
            getTypeByIndex: function(index) {
                let type = '';
                switch (index) {
                    case 1:
                        type = '/music';
                        break;
                    case 2:
                        type = '/video';
                        break;
                    case 3:
                        type = '/goods';
                        break;
                    case 4:
                        type = '/photo';
                        break;
                    case 5:
                        type = '/ticket';
                        break;
                }
                return type;
            },
            setTab: function() {
                for(let i=0; i<this.tab_origin.length; i++) {
                    if(this.tab_list_bit & 2**i) {
                        this.tabs.push(this.tab_origin[i]);
                    }
                }
            },
            getSubscriptionPrice: function() {
                axios.default
                    .get('/subscription/info/get')
                    .then(response => {
                        let res = response.data;
                        this.subscription_price = res[0].price;
                    });
            },
        },
        watch: {
            tabIndex: function (newIndex, oldIndex) {
                localStorage.setItem('store-tabIndex', newIndex);
                let type = this.getTypeByIndex(newIndex);
                this.searchItem(type);
            },
            sortIndex: function (newIndex, oldIndex) {
                localStorage.setItem('store-sortIndex', newIndex);
                this.sortItems(newIndex);
            },
            title: function(newIndex, oldIndex) {
                let type = this.getTypeByIndex(this.tabIndex);
                this.searchItem(type);
            }
        }
    }
</script>

<style scoped>
</style>
